import React, { useState, useEffect, useContext } from "react"
import { Box, Chip, CircularProgress } from '@mui/joy';
import { Text } from '../Typography';
import { Icon } from '../../assets';
import { useFormatter } from '../../utils';
import { useTranslation } from 'react-i18next';
import { useDataProvider } from '../../../mtska-frontend-data-provider';
import { Button } from "../Button"
import { AppContext } from "src/mtska-frontend-app-scaffolding"

const KPI = ({ title, dataProviderName, icon, filters, format, className = '', filterbutton = {} }) => {

    const { innerWidth } = useContext(AppContext)

    const { formatNumber, formatCurrency } = useFormatter();
    const { t } = useTranslation();

    const { items, loadAll, reloadCounter } = useDataProvider(dataProviderName)
    const [score, setScore] = useState();
    const [delta, setDelta] = useState();

    useEffect(() => {
        loadAll(filters);
    }, [reloadCounter]);

    useEffect(() => {
        setScore(items.kpi);
    }, [items])

    return (
        <Box className={"mtksa-chart mtksa-chart-kpi" + (className && ' ' + className)}>
            <Box className="iconwrapper">
                <Icon icon={icon} family="fal"></Icon>
                {filterbutton?.visible && filters && (
                    <Box className='input-button-filter-wrapper'>
                        <Button
                            customSize={innerWidth > 600 ? 'sm' : 'xs'}
                            label={filterbutton?.label}
                            onClick={() => filterbutton.callback(filters)}
                            className="input-button-filter"
                        />
                    </Box>
                )}
            </Box>
            <Box className="scorewrapper">
                <Text level="title-sm" className="title">{t(title)}</Text>
                <Text level="title-lg" className="score">
                    {
                        (score == null) && <CircularProgress />
                    }

                    {
                        (score != null && !format) && formatNumber(score)
                    }

                    {
                        (score != null && format == 'currency') && formatCurrency(score)
                    }

                </Text>
                {
                    delta && (
                        <Chip
                            className={(delta >= 0) ? "delta positive" : "delta negative"}
                            startDecorator={(delta >= 0) ? <Icon icon="faArrowUp" /> : <Icon icon="faArrowDown" />}
                        >
                            {delta}%
                        </Chip>
                    )
                }
            </Box>
        </Box>
    );
}

export default KPI;